import script from "./TableRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./TableRoom.vue?vue&type=script&setup=true&lang=js"

import "./TableRoom.vue?vue&type=style&index=0&id=6dca1412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dca1412"]])

export default __exports__